import type { JSONContent } from "@tiptap/core";

import type { Comment } from "@/react/types/Comment";
import type { MemberTag } from "@/react/types/MemberTag";

export const isTiptapDocumentBlank = (
  doc: JSONContent | undefined | null,
): boolean => {
  if (!doc) return true;
  const content = doc.content;
  if (!content || content.length === 0) return true;
  return content.every(
    node =>
      node.type === "paragraph" && (!node.content || node.content.length === 0),
  );
};

export const isTiptapComment = (comment: Comment) =>
  comment.editor === "tiptap";

export const isAuthorAiAgent = (comment: Comment) =>
  comment.community_member.type === "CommunityAiAgent";

export const isAuthorAdmin = (comment: Comment) =>
  Boolean(comment.community_member.admin);

export const isTopLevelComment = (comment: Comment) =>
  !comment.parent_comment_id;

export const isReply = (comment: Comment) => Boolean(comment.parent_comment_id);

export const isFlagged = (comment: Comment) =>
  Boolean(comment.flagged_for_approval_at);

export const hasUnresolvedReports = (comment: Comment) =>
  comment.unresolved_flagged_reports_count > 0;

// TODO: Extract to a shared location — duplicated from `@/react/components/PostsCompass`.
export const filterVisibleTags = (tags: MemberTag[] = []): MemberTag[] =>
  tags.filter(tag => Boolean(tag.is_public && tag.display_locations?.post_bio));
